import { getSaleApi, getSaleDetailApi, getSaleItemApi } from '@apis/sale';
import { Toast } from '@components/_atoms/Toast';
import { AxiosError } from 'axios';
import { getSaleDetailPayload, getSaleItemPayload, getSalePayload } from 'models/Supplement';
import { QuotationGetSaleDetailData } from 'models/swagger/data-contracts';
import {
  QuotationGetSaleDetailError,
  QuotationGetSaleListError,
  QuotationSaleGetSaleItemError,
} from 'models/swagger/data-contracts';
import { useQuery } from 'react-query';

/**
 *  판매중인 프로젝트 리스트 가져오기 Fetch
 *  @function useGetSaleFetch
 */
export const useGetSaleFetch = ({ page, finish, product_type }: getSalePayload) => {
  const {
    data: getSaleFetchData,
    isLoading: getSaleIsLoading,
    isError: getSaleIsError,
  } = useQuery(
    ['getSale', page, finish, product_type],
    async () => {
      const result = await getSaleApi({
        page,
        finish,
        product_type,
      });
      return result?.data.data;
    },
    {
      enabled: !!page,
      staleTime: 0,
      cacheTime: 0,
      keepPreviousData: true,
      onError: (err: AxiosError<QuotationGetSaleListError>) => {
        if (err.response?.data?.message) {
          Toast.error(err.response.data.message.text);
        }
      },
    },
  );
  const isCustomLoading = (!getSaleFetchData || getSaleIsLoading) && !getSaleIsError;

  return {
    getSaleFetchData,
    isCustomLoading,
  };
};

/**
 *  판매 프로젝트 상세 조회 Fetch
 *  @function useGetSaleDetailFetch
 */
export const useGetSaleDetailFetch = ({ rfq_number_id }: getSaleDetailPayload) => {
  const {
    data: getSaleDetailFetchData,
    isLoading: getSaleDetailIsLoading,
    isError: getSaleDetailIsError,
  } = useQuery(
    ['getSaleDetail', rfq_number_id],
    async () => {
      const result = await getSaleDetailApi({ rfq_number_id });
      return result?.data.data as QuotationGetSaleDetailData['data'];
    },
    {
      staleTime: 0,
      cacheTime: 0,
      enabled: !!rfq_number_id,
      onError: (err: AxiosError<QuotationGetSaleDetailError>) => {
        if (err.response?.data?.message) {
          Toast.error(err.response.data.message.text);
        }
      },
    },
  );
  const isCustomLoading = (!getSaleDetailFetchData || getSaleDetailIsLoading) && !getSaleDetailIsError;

  return {
    getSaleDetailFetchData,
    isCustomLoading,
  };
};

/**
 *  판매 프로젝트 아이템 리스트 조회 Fetch
 *  @function useGetSaleItemFetch
 */
export const useGetSaleItemFetch = ({ rfq_number_id }: getSaleItemPayload) => {
  const {
    data: getSaleItemFetchData,
    isLoading: getSaleItemIsLoading,
    isError: getSaleItemIsError,
  } = useQuery(
    ['getSaleItem', rfq_number_id],
    async () => {
      const result = await getSaleItemApi({ rfq_number_id });
      return result?.data.data;
    },
    {
      enabled: !!rfq_number_id,
      onError: (err: AxiosError<QuotationSaleGetSaleItemError>) => {
        if (err.response?.data?.message) {
          Toast.error(err.response.data.message.text);
        }
      },
    },
  );
  const isCustomLoading = (!getSaleItemFetchData || getSaleItemIsLoading) && !getSaleItemIsError;

  return {
    getSaleItemFetchData,
    isCustomLoading,
  };
};
